import { barSeriesMark } from "../bar/constant";

export const rangeColumnSeriesMark = Object.assign(Object.assign({}, barSeriesMark), {
    minLabel: {
        name: "minLabel",
        type: "text"
    },
    maxLabel: {
        name: "maxLabel",
        type: "text"
    }
});
//# sourceMappingURL=constant.js.map
